export const plans = [
  {
    title: "Starter plan",
    price: "Free",
    features: [
      "Basic annotation tools",
      "Limited access to demo models",
      "Sample datasets included",
      "Community forum access",
    ],
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755246911/powerdbyai/plan-icon_i4hnp4.png",
    path: "/",
  },
  {
    title: "Professional plan",
    price: "Free",
    features: [
      "Advanced annotation & quality control tools",
      "Full access to pre-annotated dataset library",
      "Team collaboration features",
      "Priority email support",
    ],
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755246911/powerdbyai/plan-icon_i4hnp4.png",
    path: "/",
  },
  {
    title: "Enterprise plan",
    price: "Free",
    features: [
      "Everything in Professional",
      "Dedicated account manager",
      "Custom dataset creation and annotation",
      "API access for automation",
    ],
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755246911/powerdbyai/plan-icon_i4hnp4.png",
    path: "/",
  },
];

export const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <rect width="28" height="28" rx="14" fill="#EDF8FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9457 8.62169L11.5923 16.6834L9.37568 14.315C8.96734 13.93 8.32568 13.9067 7.85901 14.2334C7.40401 14.5717 7.27568 15.1667 7.55568 15.645L10.1807 19.915C10.4373 20.3117 10.8807 20.5567 11.3823 20.5567C11.8607 20.5567 12.3157 20.3117 12.5723 19.915C12.9923 19.3667 21.0073 9.81169 21.0073 9.81169C22.0573 8.73836 20.7857 7.79336 19.9457 8.61002V8.62169Z"
      fill="#0165FE"
    />
  </svg>
);
